import { name } from '../config';
import { State } from './reducer';

type StatePiece = { [key in typeof name]: typeof State['prototype'] };

export const selectCreatorsList = (state: StatePiece) => state['creators-list'].creatorsList;
